"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFTPTradeToInterestCashFlowParameters = exports.FTPTrade = void 0;
const trade_1 = require("./trade");
class FTPTrade extends trade_1.LoanTrade {
}
exports.FTPTrade = FTPTrade;
function convertFTPTradeToInterestCashFlowParameters(ftpTrade) {
    return {
        tradeId: ftpTrade.tradeId,
        product: ftpTrade.product,
        currency: ftpTrade.currency,
        startDate: ftpTrade.startDate,
        maturityDate: ftpTrade.maturityDate,
        interestRate: ftpTrade.interestRate,
        notional: ftpTrade.notional,
        interestCalcDayCount: ftpTrade.interestCalcDayCount,
        dateRoll: ftpTrade.dateRoll,
        interestCalcFrequency: ftpTrade.interestCalcFrequency,
        interestRollingDay: ftpTrade.interestRollingDay,
        stubRule: ftpTrade.stubRule,
        firstStubDate: ftpTrade.firstStubDate,
        lastStubDate: ftpTrade.lastStubDate,
        principalAmortType: ftpTrade.principalAmortType,
        amortAmount: ftpTrade.amortAmount,
        accrualMethod: ftpTrade.accrualMethod,
        interestSchedule: ftpTrade.interestSchedule,
    };
}
exports.convertFTPTradeToInterestCashFlowParameters = convertFTPTradeToInterestCashFlowParameters;
//# sourceMappingURL=ftp.js.map